import { render, staticRenderFns } from "./ApvCard.vue?vue&type=template&id=e0aa7bfc&scoped=true&"
import script from "./ApvCard.vue?vue&type=script&lang=js&"
export * from "./ApvCard.vue?vue&type=script&lang=js&"
import style0 from "./ApvCard.vue?vue&type=style&index=0&id=e0aa7bfc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aa7bfc",
  null
  
)

export default component.exports